import { render, staticRenderFns } from "./confirmModal.vue?vue&type=template&id=67a71f62&lang=pug&"
import script from "./confirmModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./confirmModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./confirmModal.vue?vue&type=style&index=0&id=67a71f62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports